"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SunnySaberFarmErrors = exports.SunnySaberFarmJSON = void 0;
const anchor_contrib_1 = require("@saberhq/anchor-contrib");
exports.SunnySaberFarmJSON = {
    version: "0.0.0",
    name: "sunny_saber_farm",
    instructions: [
        {
            name: "newPool",
            accounts: [
                {
                    name: "creator",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "landlord",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "rewardsMint",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "pool",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "lpMint",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "payer",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "rewardsFeeAccount",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "lpFeeAccount",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "farmMint",
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "bump",
                    type: "u8",
                },
            ],
        },
        {
            name: "newVault",
            accounts: [
                {
                    name: "pool",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "owner",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "vault",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "lpTokenAccount",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "rewardsAccount",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "payer",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "rent",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "associatedTokenProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "farmProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "farmer",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "plot",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "lpTokenMint",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "farmerVault",
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "bump",
                    type: "u8",
                },
            ],
        },
        {
            name: "initMiner",
            accounts: [
                {
                    name: "vault",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "payer",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "mineProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "miner",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "quarry",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "farmMint",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "minerVault",
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "bump",
                    type: "u8",
                },
            ],
        },
        {
            name: "deposit",
            accounts: [
                {
                    name: "owner",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "pool",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "vault",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "clock",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "farm",
                    accounts: [
                        {
                            name: "vaultLpTokenAccount",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "farmProgram",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "landlord",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "plot",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "farmer",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "farmerVault",
                            isMut: true,
                            isSigner: false,
                        },
                    ],
                },
                {
                    name: "mine",
                    accounts: [
                        {
                            name: "vaultFarmTokenAccount",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "mineProgram",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "farmMint",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "rewarder",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "quarry",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "miner",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "minerVault",
                            isMut: true,
                            isSigner: false,
                        },
                    ],
                },
            ],
            args: [
                {
                    name: "amount",
                    type: "u64",
                },
            ],
        },
        {
            name: "withdraw",
            accounts: [
                {
                    name: "owner",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "pool",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "vault",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "clock",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "farm",
                    accounts: [
                        {
                            name: "vaultLpTokenAccount",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "farmProgram",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "landlord",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "plot",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "farmer",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "farmerVault",
                            isMut: true,
                            isSigner: false,
                        },
                    ],
                },
                {
                    name: "mine",
                    accounts: [
                        {
                            name: "vaultFarmTokenAccount",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "mineProgram",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "farmMint",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "rewarder",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "quarry",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "miner",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "minerVault",
                            isMut: true,
                            isSigner: false,
                        },
                    ],
                },
            ],
            args: [
                {
                    name: "amount",
                    type: "u64",
                },
            ],
        },
        {
            name: "claimMineRewards",
            accounts: [
                {
                    name: "mintWrapper",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "mintWrapperProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "minter",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "rewardsTokenMint",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "mineRewardsAccount",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "stake",
                    accounts: [
                        {
                            name: "owner",
                            isMut: false,
                            isSigner: true,
                        },
                        {
                            name: "pool",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "vault",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "tokenProgram",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "clock",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "farm",
                            accounts: [
                                {
                                    name: "vaultLpTokenAccount",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "farmProgram",
                                    isMut: false,
                                    isSigner: false,
                                },
                                {
                                    name: "landlord",
                                    isMut: false,
                                    isSigner: false,
                                },
                                {
                                    name: "plot",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "farmer",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "farmerVault",
                                    isMut: true,
                                    isSigner: false,
                                },
                            ],
                        },
                        {
                            name: "mine",
                            accounts: [
                                {
                                    name: "vaultFarmTokenAccount",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "mineProgram",
                                    isMut: false,
                                    isSigner: false,
                                },
                                {
                                    name: "farmMint",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "rewarder",
                                    isMut: false,
                                    isSigner: false,
                                },
                                {
                                    name: "quarry",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "miner",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "minerVault",
                                    isMut: true,
                                    isSigner: false,
                                },
                            ],
                        },
                    ],
                },
            ],
            args: [],
        },
        {
            name: "claimFarmRewards",
            accounts: [
                {
                    name: "mintProxyState",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "proxyMintAuthority",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "mintProxyProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "minterInfo",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "rewardsTokenMint",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "vaultRewardsAccount",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "stake",
                    accounts: [
                        {
                            name: "owner",
                            isMut: false,
                            isSigner: true,
                        },
                        {
                            name: "pool",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "vault",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "tokenProgram",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "clock",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "farm",
                            accounts: [
                                {
                                    name: "vaultLpTokenAccount",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "farmProgram",
                                    isMut: false,
                                    isSigner: false,
                                },
                                {
                                    name: "landlord",
                                    isMut: false,
                                    isSigner: false,
                                },
                                {
                                    name: "plot",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "farmer",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "farmerVault",
                                    isMut: true,
                                    isSigner: false,
                                },
                            ],
                        },
                        {
                            name: "mine",
                            accounts: [
                                {
                                    name: "vaultFarmTokenAccount",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "mineProgram",
                                    isMut: false,
                                    isSigner: false,
                                },
                                {
                                    name: "farmMint",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "rewarder",
                                    isMut: false,
                                    isSigner: false,
                                },
                                {
                                    name: "quarry",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "miner",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "minerVault",
                                    isMut: true,
                                    isSigner: false,
                                },
                            ],
                        },
                    ],
                },
            ],
            args: [],
        },
        {
            name: "withdrawClaimedRewards",
            accounts: [
                {
                    name: "owner",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "pool",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "vault",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "vaultRewardsAccount",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "rewardsDestination",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "rewardsFeeDestination",
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: "withdrawUnstakedLp",
            accounts: [
                {
                    name: "owner",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "pool",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "vault",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "vaultLpAccount",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "lpDestination",
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: "claimSaberAirdrop",
            accounts: [
                {
                    name: "vault",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "owner",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "ownerIouTokenAccount",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "pool",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "rewardsFeeIouTokenAccount",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "vaultIouTokenAccount",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "distributor",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "distributorClaimStatus",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "distributorFrom",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "payer",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "distributorProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "tokenProgram",
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "bump",
                    type: "u8",
                },
                {
                    name: "index",
                    type: "u64",
                },
                {
                    name: "amount",
                    type: "u64",
                },
                {
                    name: "proof",
                    type: {
                        vec: {
                            array: ["u8", 32],
                        },
                    },
                },
            ],
        },
        {
            name: "updateClaimFee",
            accounts: [
                {
                    name: "admin",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "pool",
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "claimFee",
                    type: {
                        defined: "MegaBPS",
                    },
                },
            ],
        },
    ],
    accounts: [
        {
            name: "Pool",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "creator",
                        type: "publicKey",
                    },
                    {
                        name: "landlord",
                        type: "publicKey",
                    },
                    {
                        name: "rewardsMint",
                        type: "publicKey",
                    },
                    {
                        name: "lpMint",
                        type: "publicKey",
                    },
                    {
                        name: "bump",
                        type: "u8",
                    },
                    {
                        name: "vaultCount",
                        type: "u64",
                    },
                    {
                        name: "admin",
                        type: "publicKey",
                    },
                    {
                        name: "pendingAdmin",
                        type: "publicKey",
                    },
                    {
                        name: "totalLpTokenBalance",
                        type: "u64",
                    },
                    {
                        name: "fees",
                        type: {
                            defined: "Fees",
                        },
                    },
                    {
                        name: "farmMint",
                        type: "publicKey",
                    },
                ],
            },
        },
        {
            name: "Vault",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "pool",
                        type: "publicKey",
                    },
                    {
                        name: "owner",
                        type: "publicKey",
                    },
                    {
                        name: "bump",
                        type: "u8",
                    },
                    {
                        name: "index",
                        type: "u64",
                    },
                    {
                        name: "lpTokenAccount",
                        type: "publicKey",
                    },
                    {
                        name: "rewardsAccount",
                        type: "publicKey",
                    },
                    {
                        name: "stakedBalance",
                        type: "u64",
                    },
                ],
            },
        },
    ],
    types: [
        {
            name: "Fees",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "rewardsAccount",
                        type: "publicKey",
                    },
                    {
                        name: "lpAccount",
                        type: "publicKey",
                    },
                    {
                        name: "claimFee",
                        type: {
                            defined: "MegaBPS",
                        },
                    },
                ],
            },
        },
        {
            name: "MegaBPS",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "megaBps",
                        type: "u64",
                    },
                ],
            },
        },
    ],
    events: [
        {
            name: "NewPoolEvent",
            fields: [
                {
                    name: "pool",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "creator",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "landlord",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "rewardsMint",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "lpMint",
                    type: "publicKey",
                    index: false,
                },
            ],
        },
        {
            name: "NewVaultEvent",
            fields: [
                {
                    name: "vault",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "pool",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "lpMint",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "owner",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "lpTokenAccount",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "rewardsAccount",
                    type: "publicKey",
                    index: false,
                },
            ],
        },
        {
            name: "DepositEvent",
            fields: [
                {
                    name: "vault",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "owner",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "mint",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "amount",
                    type: "u64",
                    index: false,
                },
            ],
        },
        {
            name: "WithdrawEvent",
            fields: [
                {
                    name: "vault",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "owner",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "mint",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "amount",
                    type: "u64",
                    index: false,
                },
            ],
        },
        {
            name: "MintPoolEvent",
            fields: [
                {
                    name: "vault",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "amount",
                    type: "u64",
                    index: false,
                },
            ],
        },
        {
            name: "BurnPoolEvent",
            fields: [
                {
                    name: "vault",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "amount",
                    type: "u64",
                    index: false,
                },
            ],
        },
        {
            name: "ClaimEvent",
            fields: [
                {
                    name: "vault",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "mint",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "amount",
                    type: "u64",
                    index: false,
                },
                {
                    name: "initialBalance",
                    type: "u64",
                    index: false,
                },
                {
                    name: "endBalance",
                    type: "u64",
                    index: false,
                },
            ],
        },
        {
            name: "WithdrawClaimedRewardsEvent",
            fields: [
                {
                    name: "vault",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "vaultInitialBalance",
                    type: "u64",
                    index: false,
                },
                {
                    name: "claimFeeAmount",
                    type: "u64",
                    index: false,
                },
                {
                    name: "userWithdrawAmount",
                    type: "u64",
                    index: false,
                },
                {
                    name: "feeDestination",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "destination",
                    type: "publicKey",
                    index: false,
                },
            ],
        },
        {
            name: "WithdrawUnstakedLPEvent",
            fields: [
                {
                    name: "vault",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "amount",
                    type: "u64",
                    index: false,
                },
                {
                    name: "destination",
                    type: "publicKey",
                    index: false,
                },
            ],
        },
    ],
    errors: [
        {
            code: 300,
            name: "Unauthorized",
            msg: "Unauthorized.",
        },
        {
            code: 301,
            name: "MathOverflow",
            msg: "Math overflow.",
        },
        {
            code: 302,
            name: "InsufficientBalance",
            msg: "Insufficient balance.",
        },
        {
            code: 303,
            name: "VaultInvariant",
            msg: "Vault invariant failed.",
        },
    ],
};
exports.SunnySaberFarmErrors = (0, anchor_contrib_1.generateErrorMap)(exports.SunnySaberFarmJSON);
//# sourceMappingURL=sunny_saber_farm.js.map